import { getCustomerTransactions } from "@/services/transactions.service";
import { useQuery } from "@tanstack/react-query";

export const useCustomerTransactions = (
  id,
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "customer-transactions",
    id,
    params.page,
    params.size,
    params.status,
    params.search,
  ];

  return useQuery({
    queryKey,
    queryFn: () =>
      getCustomerTransactions({
        ...params,
        userId: id,
      }),
    enabled: !!id && enabled,
    ...options,
  });
};
